import React from 'react'
import { Flex, Button } from 'antd'
import { isDesktop } from 'react-device-detect'

const Noticias = () => {
    return <div vertical gap={5} style={{ padding: isDesktop ? 20 : 10, marginLeft: isDesktop ? 100 : 10, marginRight: isDesktop ? 100 : 10, lineHeight: 1.1 }}>
        <div style={{ color: '#000', fontWeight: 'bold' }}>Por que é Importante Informar Sobre a Presença de Metanol em Bebidas
            Destiladas?
        </div>
        <div style={{ color: '#000', fontWeight: 'bold', marginTop: 25 }}> Autor: Ronaldo Ferreira do Nascimento   </div>
        <div style={{ color: '#000', fontWeight: 'bold' }}>Acadêmico da Academia Cearense de Química - ACQ</div>

        <p>
            As informações aqui mencionadas sobre a presença do metanol em bebidas destiladas vão
            abordar temas importantes, envolvendo a segurança pública, diferenciação entre bebidas
            normais e adulteradas, educação do consumidor, bem como do ponto de vista econômico
            (mercado de bebidas).
        </p>

        <h4>CARACTERÍSTICAS DO METANOL</h4>

        <p><b>O que é o Metanol?</b></p>

        <p>Quais as principais características do metanol?</p>
        <p>
            O <b>metanol</b> é um álcool simples, muito usado como insumo químico e energético, mas <b>altamente tóxico</b> para consumo humano.
            Por isso, sua presença em bebidas destiladas             deve ser rigorosamente controlada.
        </p>

        <p>
            Quais as principais características do metanol?
        </p>

        <ul>
            <li>Também chamado de <b>álcool metílico</b> ou <b>álcool da madeira</b>.</li>
            <li>É o <b>álcool mais simples</b> da série dos álcoois (etanol, propanol, butanol...).</li>
            <li>Líquido <b>incolor, volátil</b>, com cheiro semelhante ao do etanol.</li>
            <li>Altamente inflamável (risco de incêndio/explosão)</li>
            <li>Completamente miscível em água.</li>
            <li>Difícil de distinguir do etanol</li>
        </ul>
        <p>
            <b>Para que serve o metanol?</b>
            <ul>
                <li>Matéria-prima para produção de reagentes químicos, <b>plásticos e resinas</b>.</li>
                <li>Solvente em indústrias químicas.</li>
                <li>Combustível alternativo e aditivo em combustíveis.</li>
            </ul>
        </p>

        <p>
            <b>PRODUÇÃO DA BEBIDA DESTILADA</b>
        </p>
        <p>
            <div><b>Como é obtida uma bebida destilada?</b></div>
            <div>A produção de bebidas destiladas, são as três frações que resultam da destilação do mosto
                fermentado: "cabeça", "coração" e "cauda". A cabeça é a primeira parte e contém
                compostos voláteis e tóxicos, como o metanol, devendo ser descartada para evitar riscos
                à saúde. O coração é a fração intermediária e desejada, rica em etanol e com os compostos
                secundários que dão sabor e aroma à bebida, sendo a parte que se consome. A cauda é a
                última fração, com compostos de baixa volatilidade e menor teor alcoólico, também
                indesejável para o consumo da bebida (NASCIMENTO, 2022).
            </div>
        </p>

        <p><b>Existe metanol em bebidas não destiladas?</b></p>
        <p>O metanol é um álcool que se forma naturalmente durante o processo de fermentação,
            então todas as bebidas fermentadas (mesmo não destiladas) podem conter pequenas
            quantidades de metanol. Por exemplo, em cervejas artesanais o metanol é encontrado em
            concentrações muito baixas, geralmente irrelevantes.</p>

        <p><b>PADRÃO DE QUALIDADE DA BEBIDA DESTILADA</b></p>
        <p>
            <b>Existe legislação para o controle do teor de metanol em bebidas destiladas?</b>
        </p>
        <p>
            O padrão e a qualidade de uma bebida destilada são definidos por regulamentação pelo
            Ministério da Agricultura, Pecuária e Abastecimento (MAPA). Este estabelece teor
            alcoólico e composição química para diferentes produtos. “No Brasil, a legislação
            estabelece o limite de até 20 mg de metanol por 100 mL de álcool anidro em bebidas
            destiladas (exemplo, cachaça, uísque, vodca e gin), conforme o MAPA. “No entanto,
            existem exceções para tipos específicos de bebidas, com limites mais altos permitidos
            para rum (até 200 mg/100 mL) e aguardente de fruta (até 400 mg/100 mL), devido à
            presença natural da substância nessas matérias-primas.” O teor alcoólico (em
            porcentagem) avalia quantos mililitros de álcool absoluto existem em 100 mililitros de
            mistura hidroalcoólica (GODOY, 2025).

        </p>

        <p><b>Obs.:</b> Para uma comparação, a venda de uma dose de uma bebida alcoólica destilada
            corresponde a 30 mL.</p>

        <p><b>CONTAMINAÇÃO DE BEBIDAS DESTILADAS COM METANOL </b></p>

        <p>
            <b>Origem do alto teor de metanol em bebidas destiladas?</b>
        </p>

        <p>A origem do alto teor de metanol nesses produtos é bastante controversa, mas certamente
            o processo regular de fermentação e destilação não a explica (BOSCOLO, et al., 2000)</p>

        <p>
            <b>Por que a adulteração de bebida destilada ocorre?</b>
        </p>

        <p>
            O metanol é uma substância tóxica para os seres humanos, e sua <b>adição intencional para
                adulterar bebidas é ilegal.</b> A adulteração ocorre quando o metanol é adicionado
            ilegalmente às bebidas destiladas. Uma vez que metanol e etanol são parecidos na
            aparência e no cheiro, então é difícil para o consumidor distinguir a diferença.
        </p>

        <p>
            <b>Como diferenciar uma bebida destilada normal de uma falsificada?</b>
        </p>

        <p><b>Normal:</b></p>

        <p>
            <div> Rotulação padrão (fabricante, lote, selo fiscal).</div>
            <div>Comprada em local autorizado (com nota fiscal).</div>
            <div>Sabor, cor e cheiro compatíveis com o tipo de bebida.</div>
        </p>

        <p><b>Falsificada:</b></p>
        <p>
            <div>Usualmente vendida em garrafas sem rótulo ou com lacres falsos.</div>
            <div>Usualmente comercializada em feiras clandestinas ou de forma ilegal.</div>
            <div>Cheiro forte ou sabor estranho.</div>
            <div>Preço muito baixo comparado ao original.</div>
        </p>

        <p>
            <b>Obs.:</b> O ideal é realizar uma análise físico-química da amostra (da bebida) e comparar
            com os padrões de qualidade adotados pelo MAPA
        </p>

        <p>
            <div><b>Como pode ocorrer a contaminação da bebida destilada com metanol?</b></div>
            Contaminação por lavagem de garrafa: quando garrafas reaproveitadas são lavadas com
            metanol (por ser mais barato e similar ao etanol), logo resíduo de metanol pode
            permanecer na garrafa.
        </p>
        <p>
            Em consequência, se não houver enxágue adequado, resíduo de metanol contamina a
            bebida envasada. Isso é muito perigoso, porque mesmo pequenas quantidades de metanol
            podem levar à intoxicação.
        </p>
        <p>
            <div><b>Contaminação por diluição:</b></div>
            Alguns falsificadores diluem bebidas destiladas com água e metanol de baixa qualidade
            para aumentar o volume e diminuir custos. Após, corrigir o teor alcoólico, já que o
            metanol tem aparência e cheiro semelhantes ao etanol. Isso aumenta o risco de
            intoxicações graves, já que o consumidor não consegue diferenciar.
        </p>

        <p><b>CONTROLE DE QUALIDADE DA BEBIDA DESTILADA</b></p>

        <p>
            <div><b>Como melhorar a qualidade e evitar a falsificação das bebidas destiladas?</b></div>
            A indústria deve adotar boas práticas de fabricação e controle de qualidade para controlar
            o teor de metanol. Para isso deve adotar métodos eficientes para analisar o teor de metanol
            nas bebidas, assegurando o padrão de qualidade exigido pela legislação, bem como a
            segurança do consumidor.
        </p>

        <p>
            <div><b> Quais os métodos de detecção do metanol em bebidas destiladas?</b></div>
            A presença e quantidade de metanol (devido à sua toxicidade) em bebidas destiladas
            devem ser rigorosamente monitoradas. Nas destilarias de pequeno porte (uso de
            alambiques) o método volumétrico (mais barato) é o mais empregado, porém o metanol
            não é determinado com precisão. Nas destilarias de grande porte, o método instrumental
            (mais caro) é o mais utilizado para determinar a concentração de metanol, bem como de
            outras substâncias presentes da composição da bebida (PAULINO, et al., 2024;
            NASCIMENTO, et al., 2022, BOSCOLO, et al., 2000, CARUZO, NAGATO e
            ALABURDA, 2008; NASCIMENTO, et al., 1997).
        </p>
        <p>
            <b>Obs.:</b> No caso de consumo de bebidas destiladas em estabelecimentos comerciais, o ideal
            seria a aplicação de um teste rápido para avaliar a presença de metanol na bebida (antes
            da sua ingestão).
        </p>

        <p><b>TOXICIDADE DO METANOL</b></p>
        <p>
            <div><b>Quais os riscos à saúde conhecidos na literatura?</b></div>
            Mesmo em baixas concentrações, o metanol pode causar dor de cabeça, náusea, visão
            turva. Entretanto, em concentrações maiores causa cegueira irreversível, falência
            orgânica, morte
        </p>

        <p><b>CONSIDERAÇÕES FINAIS</b></p>
        <p>Assim, esperamos que esta nota tenha contribuído com informações ao consumidor sobre
            o metanol nas bebidas destiladas, em relação à proteção contra riscos graves à saúde,
            ajuda no combate ao mercado clandestino, bem como educar a população sobre os perigos
            de bebidas adulteradas e colaborar com os produtores regulamentados</p>

        <p>
            <b>REFERÊNCIAS</b>
            <div style={{ marginTop: 10 }}>BOSCOLO, M.; BEZERRA, C.W.B.; CARDOSO, D.R.; LIMA NETO, B.S.; FRANCO,
                D.W. Identification and dosage by HRGC of minor alcohols and esters in Brazilian sugarcane spirit. <b>Journal of the Brazilian Chemical Society</b>, v. 11, n. 1, p. 86–90, fev. 2000.</div>

            <div style={{ marginTop: 10 }}>
                CARUSO, M.S.F.; NAGATO, L.A.F.; ALABURDA. J. Avaliação do teor alcoólico e
                componentes secundários de cachaças. <b>Revista do Instituto Adolfo Lutz</b>, São Paulo, v.
                67, n. 1, p. 28–33, 1 jan. 2008.
            </div>

            <div style={{ marginTop: 10, textWrap:'wrap' }}>
                GODOY, F. Guia Completo: Teor Alcoólico das Bebidas no Brasil. Disponível em: 
                <a style={{textWrap:'wrap'}} href='https://quetzalli.com.br/blogs/drink/teoralcoolico?srsltid=AfmBOoof_07I7umbiHx8tBp2HvTGNtnrmbcAt9KqbmByyGrJk6C2_Gok' target='_blank'>
                    https://quetzalli.com.br/blogs/drink/teoralcoolico?srsltid=AfmBOoof_07I7umbiHx8tBp2HvTGNtnrmbcAt9KqbmByyGrJk6C2_Gok</a>. Acesso em: 10 out. 2025.
            </div>

            <div style={{ marginTop: 10 }}>
                PAULINO, M.F.F.; BEZERRA, A.I.M.; BRITO, R.S.; FONSECA, T.S. Análise físicoquímica de amostras de cachaças produzidas na cidade de São Benedito - CE. <b>Revista
                    Brasileira de Tecnologia Agroindustrial</b>, v. 18, n. 1, 30 jun. 2024

            </div>

            <div style={{ marginTop: 10 }}>
                NASCIMENTO, H.O; DA SILVA, M.Z.F.; ALEXANDRE, J.B.S.; VIDAL, C.B.;
                CARVALHO, T.V.; NASCIMENTO, R.F. New HS-SPME-GC-BID method for the
                determination of volatile constituents in distilled beverages. <b>Microchemical Journal</b>, v.
                181, p. 107669, 11 jun. 2022.
            </div>

            <div style={{ marginTop: 10 }}>
                NASCIMENTO, H.O. <b>Desenvolvimento e validação de método para determinação de
                    compostos voláteis em bebidas alcoólicas</b>. 2022, 79 f. Tese (Doutorado em Química) -
                Universidade Federal do Ceará. Fortaleza, 2022.

            </div>

            <div style={{ marginTop: 10 }}>
                NASCIMENTO, R.F.; MARQUES, J.C.; KEUKELEIRE, D.; LIMA NETO, B.
                S.; FRANCO, D.W. Qualitative and quantitative high-performance liquid
                chromatographic analysis of aldehydes in <b>Brazilian sugar cane spirits and other
                    distilled alcoholic beverages</b>. v. 782, n. 1, p. 13–23, 1 out. 1997
            </div>

        </p>

    </div>
}

export default Noticias